module.exports = __webpack_public_path__ + "static/img/abouttt.6fde5c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/abouttt.jpg
// module id = B+5H
// module chunks = 5